// extracted by mini-css-extract-plugin
module.exports = {"navLink":"tab-bar_navLink__2-3kn","active":"tab-bar_active__d2p96"};